module.exports = __webpack_public_path__ + "img/documental--icon.f6569475.svg";